import * as Popover from "@radix-ui/react-popover";
import { IoInformationCircle } from "react-icons/io5";

export const ItemPopover = ({ text }: { text: string }) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          className="rounded-full p-1 text-[var(--sc-muted)] hover:text-[var(--sc-text)] hover:bg-[var(--sc-border)] transition-colors border-none bg-transparent cursor-pointer"
          aria-label="Informacja"
        >
          <IoInformationCircle size={20} />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="z-50 w-52 rounded-[var(--sc-radius-lg)] border border-[var(--sc-border)] bg-[var(--sc-surface)] px-3 py-2 text-sm text-[var(--sc-text)] shadow-lg outline-none"
          sideOffset={6}
        >
          {text}
          <Popover.Arrow className="fill-[var(--sc-border)]" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
